import type { UUID } from 'node:crypto';

import { z } from 'zod';

export function generatedUUID<T extends UUID = UUID>(): T {
    return String(crypto.randomUUID()).replace(/[^\w-]/g, '_') as T;
}

export function isUUID(value: unknown): value is UUID {
    return z.string().uuid().safeParse(value).success;
}

export type { UUID };
